import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DashboardTileType } from '@store';
import { DashboardConfigurationModalComponent } from './dashboard-configuration-modal/dashboard-configuration-modal.component';
import { DashboardRefreshModalComponent } from './dashboard-refresh-modal/dashboard-refresh-modal.component';
import { DashboardTileModalComponent } from './dashboard-tile/dashboard-tile-modal/dashboard-tile-modal.component';

@Injectable({
  providedIn: 'root',
})
export class DashboardDialogService {
  dashboardConfigurationDialogRef: MatDialogRef<DashboardConfigurationModalComponent>;
  dashboardTileDialogRef: MatDialogRef<DashboardTileModalComponent>;
  dashboardRefreshDialogRef: MatDialogRef<DashboardRefreshModalComponent>;

  constructor(private dialog: MatDialog) {}

  openConfigurationDialog(): void {
    this.dashboardConfigurationDialogRef = this.dialog.open(DashboardConfigurationModalComponent, {
      width: '424px',
      panelClass: 'dashboard-configuration-dialog',
      disableClose: true,
    });
  }

  openTileDialog(dashboardTileType: DashboardTileType): void {
    this.dashboardTileDialogRef = this.dialog.open(DashboardTileModalComponent, {
      width: '588px',
      panelClass: 'dashboard-tile-dialog',
      disableClose: true,
      data: {
        tileType: dashboardTileType,
      },
    });
  }

  openRefreshDialog(): void {
    if (!this.dashboardRefreshDialogRef) {
      if (this.dashboardConfigurationDialogRef) {
        this.dashboardConfigurationDialogRef.close();
      }

      if (this.dashboardTileDialogRef) {
        this.dashboardTileDialogRef.close();
      }

      this.dashboardRefreshDialogRef = this.dialog.open(DashboardRefreshModalComponent, {
        width: '588px',
        panelClass: 'dashboard-refresh-dialog',
        disableClose: true,
      });
    }
  }
}
